export default {
  title: 'Definições',
  reservation_hours_helper: 'Estas horas definem quando os clientes podem fazer reservas online.',
  reservation_hours_alert:
    'As suas horas de reserva diferem do horário de funcionamento regular. Os clientes só podem reservar durante as horas listadas aqui.',
  activated: 'Reservas ativas',
  deactivated: 'Reservas inativas',
  buttons: {
    activate: 'Ativar',
    deactivate: 'Desativar',
  },
  error_messages: {
    no_google_place: {
      title: 'O restaurante não está ligado a nenhuma localização Google',
      description: 'Por favor, ligue o restaurante a uma localização Google',
    },
    toggle_failed: 'Não foi possível atualizar as reservas. Por favor, tente novamente.',
  },
};
